import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/talentDashboard/getPaidV2/admin/user";

export default function useGetPaidAdminUserInvoices(
  userId,
  influencerId,
  page = 1,
) {
  const url = React.useMemo(() => {
    if (!userId) return null;
    const params = new URLSearchParams({ page: String(page) });
    if (influencerId) {
      params.set("influencer_id", String(influencerId));
    }
    return `${baseEndpoint}/${userId}/invoices?${params.toString()}`;
  }, [userId, influencerId, page]);

  const { data, error, mutate, isValidating } = useSWR(url, fetcher, {
    keepPreviousData: true,
  });

  return {
    invoices: data?.invoices ?? [],
    pagination: data?.pagination ?? {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    isLoading: Boolean(userId) && !data && !error,
    isValidating,
    error,
    refresh: mutate,
  };
}
